var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPainScore2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80.524,
    height: 80.525,
    viewBox: "0 0 80.524 80.525",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-painscore2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3609",
    "data-name": "Path 3609",
    d: "M173.3-30.237A39.263,39.263,0,0,1,134.034,9.025,39.263,39.263,0,0,1,94.772-30.237,39.263,39.263,0,0,1,134.034-69.5,39.263,39.263,0,0,1,173.3-30.237",
    transform: "translate(-94.772 69.5)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2-painscore2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3620",
    "data-name": "Path 3620",
    d: "M140.325-44.934a2.633,2.633,0,0,1-2.633,2.633,2.633,2.633,0,0,1-2.633-2.633,2.633,2.633,0,0,1,2.633-2.633,2.633,2.633,0,0,1,2.633,2.633",
    transform: "translate(-135.059 47.567)",
    fill: "#00142e",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3-painscore2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3623",
    "data-name": "Path 3623",
    d: "M138.562-45.142a1.078,1.078,0,0,1-1.077,1.078,1.079,1.079,0,0,1-1.078-1.078,1.078,1.078,0,0,1,1.078-1.077,1.077,1.077,0,0,1,1.077,1.077",
    transform: "translate(-136.406 46.219)",
    fill: "#00142e",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4-painscore2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3628",
    "data-name": "Path 3628",
    d: "M123.926-44.442a2.632,2.632,0,0,0,2.633,2.633,2.632,2.632,0,0,0,2.633-2.633,2.633,2.633,0,0,0-2.633-2.633,2.633,2.633,0,0,0-2.633,2.633",
    transform: "translate(-123.926 47.075)",
    fill: "#00142e",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5-painscore2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3631",
    "data-name": "Path 3631",
    d: "M125.274-44.65a1.078,1.078,0,0,0,1.078,1.077,1.077,1.077,0,0,0,1.077-1.077,1.077,1.077,0,0,0-1.077-1.077,1.078,1.078,0,0,0-1.078,1.077",
    transform: "translate(-125.274 45.727)",
    fill: "#00142e",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pain_2",
    "data-name": "Pain 2",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3771",
    "data-name": "Group 3771",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-painscore2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3608",
    "data-name": "Path 3608",
    d: "M93.772-70.5H174.6V10.334H93.772Z",
    transform: "translate(-94.926 69.346)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3773",
    "data-name": "Group 3773",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3611",
    "data-name": "Path 3611",
    d: "M78.524,39.263A39.262,39.262,0,1,1,39.262,0,39.263,39.263,0,0,1,78.524,39.263Z",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3778",
    "data-name": "Group 3778",
    transform: "translate(42.099 21.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3617",
    "data-name": "Path 3617",
    d: "M13.645,6.823A6.823,6.823,0,1,1,6.823,0,6.823,6.823,0,0,1,13.645,6.823Z",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3780",
    "data-name": "Group 3780",
    transform: "translate(46.504 25.318)",
    clipPath: "url(#clip-path-2-painscore2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3619",
    "data-name": "Path 3619",
    d: "M134.059-48.567h7.575v7.575h-7.575Z",
    transform: "translate(-135.214 47.412)",
    fill: "#00142e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3782",
    "data-name": "Group 3782",
    transform: "translate(48.059 26.874)",
    clipPath: "url(#clip-path-3-painscore2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3622",
    "data-name": "Path 3622",
    d: "M135.406-47.219h4.464v4.464h-4.464Z",
    transform: "translate(-136.561 46.064)",
    fill: "#00142e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3784",
    "data-name": "Group 3784",
    transform: "translate(27.555 22.057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3625",
    "data-name": "Path 3625",
    d: "M0,6.823A6.823,6.823,0,1,0,6.823,0,6.823,6.823,0,0,0,0,6.823Z",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3786",
    "data-name": "Group 3786",
    transform: "translate(33.653 25.886)",
    clipPath: "url(#clip-path-4-painscore2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3627",
    "data-name": "Path 3627",
    d: "M122.926-48.075H130.5V-40.5h-7.575Z",
    transform: "translate(-124.081 46.92)",
    fill: "#00142e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3788",
    "data-name": "Group 3788",
    transform: "translate(35.209 27.442)",
    clipPath: "url(#clip-path-5-painscore2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3630",
    "data-name": "Path 3630",
    d: "M124.274-46.727h4.464v4.463h-4.464Z",
    transform: "translate(-125.428 45.572)",
    fill: "#00142e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3826",
    "data-name": "Group 3826",
    transform: "translate(21.679 52.477)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3685",
    "data-name": "Path 3685",
    d: "M35.764.312c-4.787,4.774-11.2,7.557-16.6,7.522C9.187,7.764,3.4,4.88,0,0",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3827",
    "data-name": "Group 3827",
    transform: "translate(24.226 12.724)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3686",
    "data-name": "Path 3686",
    d: "M0,2.6A14.265,14.265,0,0,1,12.568.623",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3828",
    "data-name": "Group 3828",
    transform: "translate(47.33 13.991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3687",
    "data-name": "Path 3687",
    d: "M0,.973S7.3-1.9,12.867,2.23",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3829",
    "data-name": "Group 3829",
    transform: "translate(34.892 38.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3688",
    "data-name": "Path 3688",
    d: "M.109,0S-.549,4.309,1.366,3.95s4.489,0,5.386.658,2.214.06,3.471-.539a10.443,10.443,0,0,1,2.634-.718c.6-.179-.12-2.513-.12-2.513",
    transform: "translate(0)",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPainScore2);
export default __webpack_public_path__ + "static/media/pain_score_2.d85cedb9.svg";
export { ForwardRef as ReactComponent };